import React from 'react';
import { Box as MuiBox, BoxProps } from '@mui/material';

export const Wrapper: React.FC<BoxProps> = ({
  children,
  display = 'flex',
  ...rest
}) => {
  return (
    <MuiBox display={display} {...rest}>
      {children}
    </MuiBox>
  );
};
